import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
import { RemoteLoadTables } from '../../../data/usecases/load-tables/remote-load-tables'

export const makeLoadTables = (cd:string) => new RemoteLoadTables(`/cotacao/tableTypeLoad?cdTeste${cd}`, makeAxiosHttpClient())
